"use strict";

var DataTypeConversionMixin, DisableOnSubmitMixin, HelpMixin, React, SingleInputMixin, StandardErrorDisplayMixin, TextArea, ValidationMixin;

React = require("react");

SingleInputMixin = require("./mixins/SingleInput");

ValidationMixin = require("./mixins/Validation");

StandardErrorDisplayMixin = require("./mixins/StandardErrorDisplay");

DisableOnSubmitMixin = require("./mixins/DisableOnSubmit");

HelpMixin = require("./mixins/Help");

DataTypeConversionMixin = require("./mixins/DataTypeConversion");

TextArea = React.createClass({
  displayName: "TextArea",

  mixins: [SingleInputMixin, ValidationMixin, StandardErrorDisplayMixin, DisableOnSubmitMixin, HelpMixin, DataTypeConversionMixin],
  propTypes: {
    dataKey: React.PropTypes.string
  },
  onChange: function onChange(event) {
    var value;
    value = event.target.value;
    return this.validate(value, (function (_this) {
      return function () {
        return _this.props.onDataChanged(_this.props.dataKey, _this.convertDataType(value));
      };
    })(this));
  },
  render: function render() {
    var label, ref, rows, size;
    if (this.props.displayName !== false) {
      label = React.createElement(
        "label",
        { className: "col-sm-2 control-label", htmlFor: this.props.dataKey },
        this.props.displayName
      );
    }
    size = this.props.displayName === false ? "col-sm-12" : "col-sm-10";
    rows = (ref = this.props.rows) != null ? ref : 3;
    return React.createElement(
      "div",
      { className: this.errorClasses("form-group") },
      label,
      React.createElement(
        "div",
        { className: size },
        React.createElement("textarea", {
          rows: rows,
          className: "form-control",
          name: this.props.dataKey,
          value: this.props.data,
          onChange: this.onChange,
          disabled: this.disabled(),
          placeholder: this.props.placeholder,
          title: this.props.title
        }),
        this.errorSpan(),
        this.helpSpan()
      )
    );
  }
});

module.exports = TextArea;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/TextArea.js
 ** module id = 557
 ** module chunks = 0
 **/